module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Bold.woff2
// module id = 74
// module chunks = 8